<agr-form-dialog [formGroup]="formGroup" [contentSpacing]="false" [data]="data" (confirm)="confirm($event)" (cancel)="cancel($event)" (alt)="alt($event)">
  <div style="min-width: 720px">
    @if (data.cropFieldLinks.length > 0) {
      <mat-toolbar-row>
        <mat-form-field class="text--body full-width-field" data-test="registration-search">
          <input #search type="text" [placeholder]="'search' | translate" [formControl]="searchControl" matInput data-test="registration-search-input" />
        </mat-form-field>
      </mat-toolbar-row>
    }
    <agr-notification-empty
      [isEmpty]="!isAnyRowVisible()"
      [emptyTitle]="(data.cropFieldLinks.length === 0 ? 'noCropFieldsTitle' : 'noCropFieldsSearchTitle') | translate"
      [emptyDescription]="(data.cropFieldLinks.length === 0 ? 'noCropFieldsDescription' : 'noCropFieldsSearchDescription') | translate"
      emptyActionIcon="clear"
      [emptyActionText]="'resetSearch' | translate"
      [showEmptyAction]="!isAnyRowVisible() && data.cropFieldLinks.length > 0"
      [emptyImage]="false"
      (emptyAction)="resetFilter()"
    >
      <mat-table [dataSource]="formGroupByCropFieldId | keyvalue">
        <ng-container matColumnDef="cropField">
          <mat-header-cell *matHeaderCellDef class="flex__child-4">
            <mat-checkbox [checked]="masterToggleSelected" (click)="masterToggle(); $event.preventDefault()">{{ 'selectAll' | translate }}</mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let cropFieldLink" class="flex__child-4">
            <agr-form [formGroup]="formGroupByCropFieldId[cropFieldLink.key]">
              <mat-checkbox
                formControlName="linkedToThisLocation"
                (change)="toggleLinkedToThisLocation()"
                matTooltip="{{ hasLocationPlacedOrder(cropFieldLink.value.get('shipToId')?.value) ? ('locationOrderPlaced' | translate) : '' }}"
              >
                {{ cropFieldLink.value.get('name').value }}
                {{ cropFieldLink.value.get('cropName').value ? '(' + cropFieldLink.value.get('cropName').value + ')' : '' }}
              </mat-checkbox>
            </agr-form></mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="linkedToLocation">
          <mat-header-cell *matHeaderCellDef class="flex__child-4">{{ 'linkedToOtherLocation' | translate }}</mat-header-cell>
          <mat-cell
            *matCellDef="let cropFieldLink"
            class="flex__child-4"
            [style]="cropFieldLink.value.get('linkedToThisLocation').value ? 'text-decoration: line-through' : ''"
            >{{ getOtherLocationName(cropFieldLink.value.get('shipToId')?.value) }}
            @if (hasLocationPlacedOrder(cropFieldLink.value.get('shipToId')?.value)) {
              <br />
              <div class="text--warning" style="display: contents">
                {{ 'locationOrderPlaced' | translate }}
              </div>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="locationExternalId">
          <mat-header-cell *matHeaderCellDef class="flex__child-3">{{ 'locationExternalId' | translate }}</mat-header-cell>
          <mat-cell
            *matCellDef="let cropFieldLink"
            class="flex__child-3"
            [style]="cropFieldLink.value.get('linkedToThisLocation').value ? 'text-decoration: line-through' : ''"
            >{{ getOtherLocationExternalId(cropFieldLink.value.get('shipToId')?.value) }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" [ngStyle]="{ display: row.value.get('hidden').value ? 'none' : 'flex' }"></mat-row>
      </mat-table>
    </agr-notification-empty>
  </div>
</agr-form-dialog>
